export const red = {
  900: '#C81603',
  800: '#D12206',
  700: '#D52808',
  600: '#DA300A',
  500: '#DE350B',
  400: '#E35330',
  300: '#E87254',
  200: '#EF9A85',
  100: '#F5C2B6',
  50: '#FBE7E2',
}
